import { setPageContent } from '.'
import { locale } from './locale'
import { Bulma } from './view/bulma'
import { centeredBox, errorToast } from './view/components'

/**
 * @param {Response} res
 * @returns {Promise<Response>}
 */
async function onApiError(res) {
    switch (res.status) {
        case 408:
            errorToast("408: Connection to server timed out")
            break
        case 500:
            errorToast("500: Internal Server Error")
            break
        default:
            errorToast(`${res.status} ${res.statusText}: ${await res.text()}`)
    }
    return res
}

function loadConnectionErrorPage() {
    setPageContent(centeredBox("small",
        Bulma.label(locale.string({
            enGB: "Connection to the server failed. Please verify your internet connection and try again. If you are still experiencing issues, you can contact our support at https://support.luda.farm.",
            deDE: "Die Verbindung zum Server ist fehlgeschlagen. Bitte überprüfen Sie Ihre Internetverbindung und versuchen Sie es erneut. Wenn Sie immer noch Probleme haben, können Sie unseren Support unter https://support.luda.farm kontaktieren.",
            frFR: "La connexion au serveur a échoué. Veuillez vérifier votre connexion internet et réessayer. Si vous rencontrez toujours des problèmes, vous pouvez contacter notre service d'assistance à l'adresse https://support.luda.farm.",
            svSE: "Anslutningen till servern misslyckades. Vänligen verifiera din internetanslutning och försök igen. Om du fortfarande upplever problem kan du kontakta vår support på https://support.luda.farm.",
        })),
        Bulma.button(
            {
                onClick: () => window.location.href = "/",
                styles: ['is-primary'],
            },
            locale.string({
                enGB: "Try again",
                deDE: "Erneut versuchen",
                frFR: "Réessayez",
                svSE: "Försök igen",
            }),
        ),
    ))
}

export {
    loadConnectionErrorPage,
    onApiError
}
